<template>
  <v-container grid-list-md>
    <v-layout justify-center row wrap>
      <v-flex xs12>
        <w-main-title
          class="pb-0"
          title="Galería"
          :breadcrumbs="breadcrumbs"
        ></w-main-title>
      </v-flex>
      <v-flex xs12>
        <div class="text-right">
          <v-btn :loading="picking" color="secondary" rounded @click="$refs.file.click()">
            <v-icon left>fas fa-image</v-icon>
            Añadir Imágenes
          </v-btn
          >
          <input
            ref="file"
            type="file"
            accept="image/*"
            multiple
            style="display:none;"
            @change="pickFiles"
          />
        </div>
        <v-layout row wrap class="text-center" v-if="loading">
          <v-flex>
            <v-progress-circular
              color="primary"
              width="2"
              indeterminate
            ></v-progress-circular>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-start v-else>
          <template v-if="photos.length === 0">
            <v-flex xs12 class="text-center">
              <h3 class="font-weight-light">
                No posee imágenes en su galería
              </h3>
            </v-flex>
          </template>
          <template v-else>
            <v-flex xs4 sm3 md2 v-for="(photo, i) in photos" :key="i">
              <v-card class="pointer kim-card outlined hover pa-4" @click="viewSingleImage(photo, i)">
                <v-img :src="photo.url" :lazy-src="photo.url" aspect-ratio="1">
                  <template v-slot:placeholder>
                    <v-layout fill-height align-center justify-center ma-0>
                      <v-progress-circular
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
              </v-card>
            </v-flex>
            <v-flex xs4 sm3 md2 v-if="nextPageUrl">
              <v-card
                height="100%"
                class="primary white--text mt-1"
                style="cursor:pointer;"
                @click="loadNextPage"
              >
                <v-layout row wrap fill-height align-center justify-center>
                  <v-flex xs12 class="text-center" v-if="loadingNext">
                    <v-progress-circular
                      color="white"
                      width="2"
                      indeterminate
                    ></v-progress-circular>
                  </v-flex>
                  <v-flex xs12 class="text-center pa-3" v-else>
                    <v-icon large color="white">fas fa-image</v-icon>
                    <h4 class="font-weight-regular">
                      Cargar más<br />imágenes.
                    </h4>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </template>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-dialog v-model="modal" max-width="700px" >
      <v-card>
        <v-card-text style="position:relative;">
          <v-btn
            small
            rounded
            color="error"
            class="delete px-3"
            @click="modalDelete = true"
            :loading="deleting"
          >
            <v-icon small delete :left="$vuetify.breakpoint.mdAndUp"
              >fas fa-trash</v-icon
            >
            <span class="hidden-sm-and-down">eliminar esta Imagen</span>
          </v-btn>
          <v-img
            :src="selected.url"
            :lazy-src="selected.url"
            alt=""
            style="position:relative;max-height:600px;"
          >
            <v-btn
              icon
              class="white elevation-10 next-button"
              @click="next"
              :disabled="selectedIndex >= photos.length - 1"
            >
              <v-icon class="grey--text">fas fa-chevron-right</v-icon>
            </v-btn>
            <v-btn
              icon
              class="white elevation-10 prev-button"
              @click="prev"
              :disabled="selectedIndex <= 0"
            >
              <v-icon class="grey--text">fas fa-chevron-left</v-icon>
            </v-btn>
            <template v-slot:placeholder>
              <v-layout fill-height align-center justify-center ma-0>
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </v-layout>
            </template>
          </v-img>
          <div class="image-texts mt-3 text-center">
            <h4 class="primary--text">
              {{ selectedIndex + 1 }}. {{ selected.title }}
            </h4>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="modalDelete" max-width="300px">
      <v-card>
        <v-card-text class="text-center">
          <p>
            ¿Confirmas que deseas borrar esta imagen?
          </p>
          <v-btn color="primary" @click="deleteImage">Si, eliminar</v-btn>
          <v-btn @click="modalDelete = false">Cancelar</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog scrollable v-model="addModal" max-width="500" persistent>
      <v-card max-height="500" >
        <v-card-text>
          <v-flex xs12 >
            <v-card v-for="(ph, i) in newImages" :key="i" class="mx-2 my-3 pa-1" color="secondary-card">
              <v-img
                  :src="ph.url"
                  aspect-ratio="2.75"
                  contain
              ></v-img>

              <v-card-title primary-title>
                <v-flex xs12 >
                  <h3 class="title mb-0">Agrega una descripción (opcional)</h3>
                  <div class="py-2">
                    <v-textarea
                        hide-details
                        fillled
                        class="mx-1 pb-2"
                        placeholder="Ej. 'Nuestra nueva oficina', 'Otro cliente satisfecho', etc..."
                        v-model="ph.title"
                    ></v-textarea>
                  </div>
                </v-flex>
              </v-card-title>


            </v-card>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small @click="cancelImages" depressed>cancelar</v-btn>

          <v-btn
              class="primary"
              small
              @click="uploadImages"
              :loading="uploading"
          >añadir</v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>
  </v-container>
</template>
<script>
import { ApiUtils } from '@/utils/ApiUtils'

export default {
  components: {
    WMainTitle: () => import('@/components/common/WMainTitle')
  },
  data() {
    return {
      breadcrumbs: [
        {
          text: 'Galería',
          disabled: true,
          href: ''
        }
      ],
      photos: [],
      modal: false,
      selected: {
        id:  null,
        title: '',
        url: null,
        checksum: ''
      },
      selectedIndex: null,
      modalDelete: false,
      uploading: false,
      addModal: false,
      newImages: [],
      newImagesFiles: [],
      picking: false,
      loading: false,
      totalItems: 0,
      nextPageUrl: null,
      loadingNext: false,
      deleting: false
    }
  },
  async mounted() {
    await this.loadGallery()
  },
  methods: {
    async ask(url) {
      try {
        const response = await ApiUtils.makeGet(url)
        if (response.ok) {
          const json = await response.json()
          this.totalItems = json.result.images.total
          this.nextPageUrl = json.result.images.next_page_url
          return json.result.images.data.map(photo => {
            return {
              title: photo.name,
              url: photo.path,
              id: photo.id,
              checksum: photo.checksum
            }
          })
        }
        return []
      } catch (error) {

      }
    },
    async loadGallery() {
      try {
        this.loading = true
        const { id } = this.$store.getters.currentProvider
        const url = `provider/${id}/images`
        this.photos = await this.ask(url)
      } catch (error) {

      } finally {
        this.loading = false
      }
    },
    loadNextPage() {

      if (!this.nextPageUrl || this.loadingNext) return
      try {
        this.loadingNext = true
        const url = this.nextPageUrl.split('/v1/')[1]
        const photos = this.ask(url)
        this.photos = [...this.photos, ...photos]
      } catch (error) {

      } finally {
        this.loadingNext = true
      }
    },
    viewSingleImage(photo, index) {
      this.selected = photo
      this.modal = true
      this.selectedIndex = index
    },
    async deleteImage() {
      try {
        this.modalDelete = false
        this.deleting = true
        const { id } = this.$store.getters.currentProvider
        if (!this.selected.id) return
        const url = `provider/${id}/images`
        const response =  await ApiUtils.makeDelete(url, this.selected.id)
        if (response.ok) {
          this.$store.commit('showSnackBar', 'Imágen Eliminada')
          this.modal = false
          this.selected = {
            id: null,
            title: '',
            url: null,
            checksum: ''
          },
          this.photos.splice(this.selectedIndex, 1)
        }
      } catch (error) {

      } finally {
        this.deleting = false
      }


    },
    next() {
      if (this.selectedIndex >= this.photos.length - 1) return
      this.selectedIndex++
      this.selected = this.photos[this.selectedIndex]
    },
    prev() {
      if (this.selectedIndex <= 0) return
      this.selectedIndex--
      this.selected = this.photos[this.selectedIndex]
    },
    pickFiles(ev) {
      this.newImages = []
      this.newImagesFiles = []
      const files = [...ev.target.files]
      if (files.length === 0) return
      this.picking = true
      files.forEach(file => {
        const fr = new FileReader()
        fr.readAsDataURL(file)
        fr.addEventListener('load', () => {
          this.newImages.push({ title: '', url: fr.result })
          this.newImagesFiles.push(file)
        })
      })
      this.picking = false
      this.addModal = true
    },
    cancelImages() {
      this.addModal = false
      this.newImages = []
      this.newImagesFiles = []
      this.uploading = false
      this.picking = false
    },
    async uploadImages() {
      this.uploading = true
      // this.photos = [
      //   ...this.photos,
      //   ...JSON.parse(JSON.stringify(this.newImages))
      // ]
      const data = this.newImages.map((item, i) => {
        delete item.url
        item.image = this.newImagesFiles[i]
        return item
      })
      const images = { images: data }
      const response = await this.imagesToApi(images)
      this.cancelImages()
    },
    async imagesToApi(payload) {
      const { id } = this.$store.getters.currentProvider
      const url = `provider/${id}/images`
      const response = await ApiUtils.makePost(url, payload)
      if (response.ok) {
        const json = await response.json()
        const photos = json.result.images.map(photo => {
          return {
            title: photo.name,
            url: photo.path,
            id: photo.id,
            checksum: photo.checksum
          }
        })
        this.photos = [...this.photos, ...photos]

        this.$store.commit('showSnackBar', 'Imágenes agregadas')
      }
    }
  }
}
</script>
<style scoped>
.pointer {
  cursor: pointer;
}
.delete {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 10;
}
.next-button {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
.prev-button {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
</style>
